<template>
  <section-view class="view" :title="title" :tips="tips">
    <ul>
      <li v-for="(item, index) in list" :key="index" @click="$emit('selected', item)">
        <img :src="item.image_url_small" />{{item.item_dict_name}}
      </li>
    </ul>
  </section-view>
</template>

<script>
  import SectionView from "@/components/SectionView";
  /**
   * 标签卡片
   */
  export default {
    name: "TagCard",
    components: {SectionView},

    props: {
      // 提示
      tips: {
        type: Boolean,
        default: false
      },
      // 标题
      title: {
        type: String,
        require: true
      },
      // 内容
      list: {
        type: Array,
        require: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  .view {
    padding: 30px 0 30px 10px;

    ::v-deep header {
      margin: 0 30px 0 20px;
    }

    ul {
      flex-wrap: wrap;
      justify-content: flex-start;

      li {
        height: 80px;
        background: #E0EDFF;
        border-radius: 40px;
        margin-bottom: 20px;
        margin-right: 10px;
        padding: 0 30px;
        display: flex;
        align-items: center;
        font-size: 32px;
        color: #333333;
        flex-shrink: 0;

        img {
          width: 40px;
          height: 40px;
          margin-right: 10px;
        }
      }
    }
  }
</style>